<template>
  <div
    class="popup_wrap"
    style="top: -85px; width:800px;"
  >
    <button
      class="layer_close"
      @click="$emit('close')"
    >
      close
    </button>
    <form>
      <div class="popup_cont">
        <h1 class="page_title">{{ $t('msg.COUP100.061') }}</h1>
        <h1 style="font-size: 120%;">{{ $t('msg.COUP100.063') }}</h1>
        <div class="content_box" style="margin-top: 3px;"><!-- content_box -->
          <h1 style="font-size: 100%;">{{ $t('msg.COUP100.064') }}</h1>
          <h1 v-show="currentServiceLang !== 'JP'" style="margin-top: 3px; font-size: 100%;">{{ $t('msg.COUP100.065') }}</h1>
          <h1 v-show="currentServiceLang !== 'JP'"><br>· {{ $t('msg.COUP100.066') }}</h1>
          <h1 v-show="currentServiceLang !== 'JP'" style="margin-top: 3px; font-size: 100%;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('msg.COUP100.067') }}<br></h1>
          <h1 v-show="currentServiceLang !== 'JP'" style="margin-top: 5px;">· {{ $t('msg.COUP100.068') }}</h1>
          <h1 v-show="currentServiceLang !== 'JP'" style="margin-top: 3px; font-size: 100%;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('msg.COUP100.069') }}<br></h1>
          <h1 v-show="currentServiceLang !== 'JP'" style="margin-top: 5px;">· {{ $t('msg.COUP100.070') }}</h1>
          <h1 v-show="currentServiceLang !== 'JP'" style="margin-top: 3px; font-size: 100%;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('msg.COUP100.071') }}<br></h1>
          <h1 v-show="currentServiceLang !== 'JP'" style="margin-top: 5px;">· {{ $t('msg.COUP100.072') }}</h1>
          <h1 v-show="currentServiceLang !== 'JP'" style="margin-top: 3px; font-size: 100%;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('msg.COUP100.073') }}<br></h1>
        </div>
        <h1 style="font-size: 120%;"><br>{{ $t('msg.COUP100.083') }}</h1>
        <div class="content_box" style="margin-top: 3px;"><!-- content_box -->
          <h1 style="font-size: 100%;">{{ $t('msg.COUP100.074') }}</h1>
          <h1 v-show="currentServiceLang == 'JP'" style="font-size: 100%;">{{ $t('msg.COUP100.084') }}</h1>
          <h1 v-show="currentServiceLang == 'JP'" style="font-size: 100%;">{{ $t('msg.COUP100.085') }}</h1>
          <h1 v-show="currentServiceLang !== 'JP'"><br>· {{ $t('msg.COUP100.075') }}</h1>
          <h1 v-show="currentServiceLang !== 'JP'" style="margin-top: 3px; font-size: 100%;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('msg.COUP100.076') }}<br></h1>
          <h1 v-show="currentServiceLang !== 'JP'" style="margin-top: 5px;">· {{ $t('msg.COUP100.077') }}</h1>
          <h1 v-show="currentServiceLang !== 'JP'" style="margin-top: 3px; font-size: 100%;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('msg.COUP100.078') }}<br></h1>
          <h1 v-show="currentServiceLang !== 'JP'" style="margin-top: 5px;">· {{ $t('msg.COUP100.079') }}</h1>
          <h1 v-show="currentServiceLang !== 'JP'" style="margin-top: 3px; font-size: 100%;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('msg.COUP100.067') }}<br></h1>
          <h1 v-show="currentServiceLang !== 'JP'" style="margin-top: 5px;">·  {{ $t('msg.COUP100.070') }}</h1>
          <h1 v-show="currentServiceLang !== 'JP'" style="margin-top: 3px; font-size: 100%;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('msg.COUP100.071') }}<br></h1>
          <h1 v-show="currentServiceLang !== 'JP'" style="margin-top: 5px;">· {{ $t('msg.COUP100.072') }}</h1>
          <h1 v-show="currentServiceLang !== 'JP'" style="margin-top: 3px; font-size: 100%;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('msg.COUP100.080') }}<br></h1>
        </div>
        <h1 style="font-size: 120%;"><br>{{ $t('msg.COUP100.081') }}</h1>
        <div class="content_box" style="margin-top: 3px;"><!-- content_box -->
          <h1 style="font-size: 100%;">{{ $t('msg.COUP100.082') }}</h1>
          <h1 v-show="currentServiceLang == 'JP'" style="font-size: 100%;">{{ $t('msg.COUP100.086') }}</h1>
        </div>
        <h1 v-show="currentServiceLang == 'JP'" style="font-size: 120%;"><br>{{ $t('msg.COUP100.087') }}</h1>
        <div v-show="currentServiceLang == 'JP'" class="content_box" style="margin-top: 3px;"><!-- content_box -->
          <h1 style="font-size: 100%;">{{ $t('msg.COUP100.088') }}</h1>
          <h1 style="font-size: 100%;">{{ $t('msg.COUP100.089') }}</h1>
        </div>
        <div style="text-align: center;">
          <a class="button blue lq" style="font-size: larger; margin-top: 10px; " href="#" @click.prevent="closeBtn()">{{ $t('msg.COUP100.060') }}</a>
        </div>
      </div>
    </form>
  </div>
</template>

<script>

import { rootComputed } from '@/store/helpers'

export default {
  name: 'KmtcCouponPersonInfoPop',
  components: {
    WinLayerPop: () => import('@/pages/trans/popup/WinLayerPop')
  },
  props: {
    parentSubInfo: {
      type: Object,
      default: function () {
        return {
          userName: ''
        }
      }
    }
  },
  data () {
    return {
      userName: ''
    }
  },
  computed: {
    ...rootComputed,
    currentServiceLang () {
      return localStorage.getItem('service_ctrcd')
    }
  },
  created () {
    if (this.auth !== undefined) {
      this.lang = this.auth.serviceLang
    }
    this.initParam()
  },
  methods: {
    // init parameter
    async initParam () {
      this.userName = this.parentSubInfo.userName
    },
    closeBtn () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
  .tbl_search th {vertical-align: top;}
</style>
